import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { kycThunk } from './thunks';
import {
    State,
    KYCStatus,
    MultipleChoiceExamStep,
} from './types';

const initialState: State = {
    KYC_ID_Photo: null,
    KYC_Status: 'Pending',
    exitExamModal: false,
    examRulesModal: false,
    KYC_Personal_Photo: null,
    multipleChoiceExamStep: 'KYC',
};

export const examSlice = createSlice({
    name: 'exam',
    initialState,
    reducers: {
        setMultipleChoiceExamStep: (state, action: PayloadAction<MultipleChoiceExamStep>) => {
            state.multipleChoiceExamStep = action.payload;
        },
        setKYC_ID_Photo: (state, action: PayloadAction<string | null>) => {
            state.KYC_ID_Photo = action.payload;
        },
        setKYC_Personal_Photo: (state, action: PayloadAction<string | null>) => {
            state.KYC_Personal_Photo = action.payload;
        },
        setKYC_Status: (state, action: PayloadAction<KYCStatus>) => {
            state.KYC_Status = action.payload;
        },
        setExamRulesModal: (state, action: PayloadAction<boolean>) => {
            state.examRulesModal = action.payload;
        },
        setExitExamModal: (state, action: PayloadAction<boolean>) => {
            state.exitExamModal = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(kycThunk.fulfilled, (state) => {
                state.KYC_Status = 'Approved';
            })
            .addCase(kycThunk.rejected, (state) => {
                state.KYC_Status = 'Reject';
            })
    }
});

export const {
    setKYC_Status,
    setKYC_ID_Photo,
    setExitExamModal,
    setExamRulesModal,
    setKYC_Personal_Photo,
    setMultipleChoiceExamStep,
} = examSlice.actions;
